import { useCallback, useState } from "react"

import { useParams } from "react-router-dom"

import { DocumentEditModal, API_MODULE_DOCUMENT } from "@l2r-front/l2r-app-doc"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { NoteAddRoundedIcon } from "@l2r-front/l2r-icons"
import { useNetworksStateContext, useRoleIsReadOnly } from "@l2r-front/l2r-networks"
import { BottomSheetContent, MoreMenu, useIsMobileDevice } from "@l2r-front/l2r-ui"
import { NavigationOrigins, useNavigateWithSearchParams } from "@l2r-front/l2r-utils"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { RiskZoneAddDocumentForm } from "../../forms/RiskZoneAddDocumentForm"

import { RiskZoneDocumentList } from "../RiskZoneDocumentList"
import { RiskZonesGrades } from "../RiskZonesGrades"
import { RiskZonesTrafficInfo } from "../RiskZonesTrafficInfo"

import * as Styled from "./RiskZonesDetailSidebar.styled"

export function RiskZonesDetailSidebar() {

    const [documentAddModalOpen, setDocumentAddModalOpen] = useState(false)

    const { t } = useTranslation(I18N_NAMESPACE)
    const { riskZoneId, road } = useParams()
    const { selectedNetwork } = useNetworksStateContext()
    const navigate = useNavigateWithSearchParams()
    const readOnly = useRoleIsReadOnly()
    const isMobile = useIsMobileDevice()

    const navigateBack = useCallback(() => {
        navigate(`../${road}`, { navigationOrigin: NavigationOrigins.ROAD_FROM_BACK_DETAIL })
    }, [navigate, road])

    return (
        <BottomSheetContent
            id="riskzones-sidebar"
            onBack={road ? navigateBack : null}
            title={t(I18N_NAMESPACE, "containers.riskZonesDetailSidebar.title", { id: riskZoneId })}
            titleSideComponent={
                <MoreMenu
                    menuConfig={[
                        {
                            enabled: selectedNetwork.modules.includes(API_MODULE_DOCUMENT) && !readOnly,
                            id: "add-document",
                            label: t(I18N_NAMESPACE, "containers.riskZonesDetailSidebar.addDocument"),
                            icon: <NoteAddRoundedIcon color="objects/object-black" />,
                            props: {
                                onClick: () => setDocumentAddModalOpen(true),
                            },
                        },
                    ]} />}
        >
            <Styled.Container>
                <Styled.ContentWrapper>
                    <Styled.RoadDetailInfo isMobile={isMobile} road={road} />
                    <RiskZonesGrades />
                    <RiskZonesTrafficInfo />
                    <RiskZoneDocumentList riskZoneId={riskZoneId} />
                </Styled.ContentWrapper>
            </Styled.Container>
            {documentAddModalOpen && <DocumentEditModal
                open={documentAddModalOpen}
                onClose={() => setDocumentAddModalOpen(false)}
                FormComponent={RiskZoneAddDocumentForm}
                riskZoneId={riskZoneId}
            />}
        </BottomSheetContent>
    )
}